import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    number: '01',
    description: "Identificas el 'Muro de Fricción' que está deteniendo tu tarea actual."
  }, {
    number: '02',
    description: 'Aplicas el Reductor de 30 Segundos para engañar al motor de arranque de tu cerebro.'
  }, {
    number: '03',
    description: 'Usas la Micro-Inercia generada para encadenar acciones sin depender de la motivación.'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-104">
      <FadeIn data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-107">
            Cómo funciona
          </h2>
        </div>
      </FadeIn>

      <div className="space-y-8 md:space-y-12" data-id="element-108">
        {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-109">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 group" data-id="element-110">
              <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-full bg-slate-800 border-2 border-amber-500/30 flex items-center justify-center text-3xl md:text-4xl font-heading font-bold text-amber-500 group-hover:border-amber-500 group-hover:shadow-[0_0_20px_rgba(245,158,11,0.3)] transition-all duration-300" data-id="element-111">
                {step.number}
              </div>
              <div className="flex-1 text-center md:text-left pt-2 md:pt-6" data-id="element-112">
                <p className="text-xl md:text-2xl text-slate-300 leading-relaxed" data-id="element-113">
                  {step.description}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}